exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tips-information .tips {\n  background-color: #fff;\n  margin-bottom: 40px;\n}\n.tips-information .tips h3 {\n  color: #44414a;\n  font-size: 20px;\n  font-weight: 700;\n  margin: 0;\n}\n.tips-information .tips .date {\n  width: 100%;\n  float: left;\n  margin: 5px 0 15px 0;\n  color: #6b7b8e;\n  font-size: 17px;\n  font-weight: 400;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/tips/tips.component.less
// module id = ../../../../../src/app/tips/tips.component.less
// module chunks = main